import Joi from 'joi';
import { rutValidation } from '../../../../helpers/RutValidator';

export const schema = Joi.object({
  rut: rutValidation.rut().validateRut(),
  clientName: Joi.string()
    .min(3)
    .error(new Error('Debe ingresar su nombre completo.')),
  phoneMandate: Joi.string()
    .min(9)
    .max(9)
    .pattern(new RegExp(/^\d+$/))
    .error(new Error('El teléfono debe contener 9 dígitos.')),
  mobileOperator: Joi.string().min(3).error(new Error('Operador es requerido')),
  charge: Joi.string()
    .max(7)
    .pattern(new RegExp(/^\d+$/))
    .error(new Error('Máximo del monto es de 7 dígitos.')),
  email: Joi.string()
    .pattern(
      new RegExp(/^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i),
    )
    .error(new Error('Formato de correo inválido.')),
  phone: Joi.string()
    .min(9)
    .max(9)
    .pattern(new RegExp(/^\d+$/))
    .error(new Error('El teléfono debe contener 9 dígitos.')),
  comment: Joi.string()
    .allow(null, '')
    .max(250)
    .error(new Error('Máximo 250 caracteres.')),
});
